import * as Bixby from './../../core';

export interface ReleaseFeatureFlagsState {
  data?: Bixby.Models.ReleaseFeatureFlag[];
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
}

export const RELEASE_FEATURE_FLAGS_LOADING = 'RELEASE_FEATURE_FLAGS_LOADING';
export const RELEASE_FEATURE_FLAGS_SUCCESS = 'RELEASE_FEATURE_FLAGS_SUCCESS';
export const RELEASE_FEATURE_FLAGS_FAILURE = 'RELEASE_FEATURE_FLAGS_FAILURE';

interface ReleaseFeatureFlagsLoading extends Bixby.Models.BixbyAction<undefined, typeof RELEASE_FEATURE_FLAGS_LOADING> {
  type: typeof RELEASE_FEATURE_FLAGS_LOADING;
}

interface ReleaseFeatureFlagsSuccess
  extends Bixby.Models.BixbyAction<Bixby.Models.ReleaseFeatureFlag[], typeof RELEASE_FEATURE_FLAGS_SUCCESS> {
  type: typeof RELEASE_FEATURE_FLAGS_SUCCESS;
  payload: Bixby.Models.ReleaseFeatureFlag[];
}

interface ReleaseFeatureFlagsFailure
  extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof RELEASE_FEATURE_FLAGS_FAILURE> {
  type: typeof RELEASE_FEATURE_FLAGS_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type ReleaseFeatureFlagsActionTypes =
  | ReleaseFeatureFlagsLoading
  | ReleaseFeatureFlagsSuccess
  | ReleaseFeatureFlagsFailure;
